import { usePostHog } from "posthog-js/react";
import { useRef } from "react";

export function useTrackTopicsChange() {
  const posthog = usePostHog();
  const previousTopics = useRef<number[]>([]);

  const trackTopicsChange = (topics: number[]) => {
    const hasTopicsChanged = !(
      topics.length === previousTopics.current.length &&
      topics.every((topic, index) => topic === previousTopics.current[index])
    );

    if (hasTopicsChanged) {
      posthog.capture("topics_changed", {
        topics: topics,
      });
      previousTopics.current = [...topics];
    }
  };

  return trackTopicsChange;
} 